export default "__VITE_ASSET__yg4d_M67__"